import { useEffect, useRef } from "react";

export default function GoogleOneTap({ onSuccess }) {
  const buttonRendered = useRef(false);
  const oneTapPrompted = useRef(false);

  useEffect(() => {
    const clientIdMeta = document.querySelector(
      'meta[name="google-signin-client_id"]'
    );
    const clientId = clientIdMeta ? clientIdMeta.content : null;

    if (!clientId) {
      console.error("Missing google client_id meta tag");
      return;
    }

    const interval = setInterval(() => {
      if (window.google?.accounts?.id) {
        clearInterval(interval);

        // Initialize Google One Tap
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: onSuccess, 
          auto_select: false, 
          cancel_on_tap_outside: false,
        });

        // Show One Tap only once
        if (!oneTapPrompted.current) {
          window.google.accounts.id.prompt();
          oneTapPrompted.current = true;
        }

        // Render Google login button only once
        const btn = document.getElementById("g_button");
        if (btn && !buttonRendered.current) {
          window.google.accounts.id.renderButton(btn, {
            theme: "outline",
            size: "large",
            text: "continue_with",
          });
          buttonRendered.current = true;
        }
      }
    }, 300);

    return () => clearInterval(interval);
  }, [onSuccess]);

  return (
    <>
    <div className="google-btn-wrapper">
      <div id="g_button"></div>
    </div>
      <div id="g_id_onetap"></div>
    </>
  );
}